const code2region = {
	'ad': {name:'Республика Адыгея', fs_code:1, oktmo:79, area:7792},
	'al': {name:'Алтайский край', fs_code:22, oktmo:1, area:167996},
	'am': {name:'Амурская область', fs_code:28, oktmo:10, area:361908},
	'ar': {name:'Архангельская область', fs_code:29, oktmo:11, area:589913},
	'as': {name:'Астраханская область', fs_code:30, oktmo:12, area:49024},
	'bl': {name:'Белгородская область', fs_code:31, oktmo:14, area:27134},
	'bn': {name:'Брянская область', fs_code:32, oktmo:15, area:34857},
	'br': {name:'Республика Бурятия', fs_code:3, oktmo:81, area:351334},
	'bs': {name:'Республика Башкортостан', fs_code:2, oktmo:80, area:142947},
	'cc': {name:'Чеченская Республика', fs_code:20, oktmo:96, area:16171},
	'ch': {name:'Чукотский автономный округ', fs_code:87, oktmo:77, area:721481},
	'cl': {name:'Челябинская область', fs_code:74, oktmo:75, area:88529},
	'cr': {name:'Республика Крым', fs_code:90, oktmo:35, area:26081},
	'cu': {name:'Чувашская Республика', fs_code:21, oktmo:97, area:18343},
	'da': {name:'Республика Дагестан', fs_code:5, oktmo:82, area:50270},
	'eu': {name:'Еврейская автономная область', fs_code:79, oktmo:99, area:36271},
	'ha': {name:'Хабаровский край', fs_code:27, oktmo:8, area:787633},
	'hk': {name:'Республика Хакасия', fs_code:19, oktmo:95, area:61569},
	'ht': {name:'Ханты-Мансийский автономный округ - Югра', fs_code:86, oktmo:718, area:534801},
	'in': {name:'Республика Ингушетия', fs_code:6, oktmo:26, area:3123},
	'ir': {name:'Иркутская область', fs_code:38, oktmo:25, area:774846},
	'iv': {name:'Ивановская область', fs_code:37, oktmo:24, area:21437},
	'ka': {name:'Камчатский край', fs_code:41, oktmo:30, area:464275},
	'kb': {name:'Кабардино-Балкарская Республика', fs_code:7, oktmo:83, area:12470},
	'kc': {name:'Карачаево-Черкесская Республика', fs_code:9, oktmo:91, area:14277},
	'ki': {name:'Кировская область', fs_code:43, oktmo:33, area:120374},
	'kj': {name:'Калужская область', fs_code:40, oktmo:29, area:29777},
	'kk': {name:'Республика Калмыкия', fs_code:8, oktmo:85, area:74731},
	'kl': {name:'Республика Карелия', fs_code:10, oktmo:86, area:180520},
	'km': {name:'Кемеровская область', fs_code:42, oktmo:32, area:95725},
	'kn': {name:'Калининградская область', fs_code:39, oktmo:27, area:15125},
	'ko': {name:'Республика Коми', fs_code:11, oktmo:87, area:416774},
	'kr': {name:'Красноярский край', fs_code:24, oktmo:4, area:2366797},
	'ks': {name:'Краснодарский край', fs_code:23, oktmo:3, area:75485},
	'kt': {name:'Костромская область', fs_code:44, oktmo:34, area:60211},
	'ku': {name:'Курганская область', fs_code:45, oktmo:37, area:71488},
	'ky': {name:'Курская область', fs_code:46, oktmo:38, area:29997},
	'le': {name:'Ленинградская область', fs_code:47, oktmo:41, area:83908},
	'lp': {name:'Липецкая область', fs_code:48, oktmo:42, area:24047},
	'lt': {name:'Республика Алтай', fs_code:4, oktmo:84, area:92903},
	'ma': {name:'Магаданская область', fs_code:49, oktmo:44, area:462464},
	'mc': {name:'Московская область', fs_code:50, oktmo:46, area:44329},
	'mk': {name:'Москва', fs_code:77, oktmo:45, area:2561},
	'ml': {name:'Республика Марий Эл', fs_code:12, oktmo:88, area:23375},
	'mr': {name:'Республика Мордовия', fs_code:13, oktmo:89, area:26128},
	'mu': {name:'Мурманская область', fs_code:51, oktmo:47, area:144902},
	'ne': {name:'Ненецкий автономный округ', fs_code:83, oktmo:118, area:176810},
	'nn': {name:'Нижегородская область', fs_code:52, oktmo:22, area:76624},
	'no': {name:'Новгородская область', fs_code:53, oktmo:49, area:54501},
	'nv': {name:'Новосибирская область', fs_code:54, oktmo:50, area:177756},
	'ob': {name:'Оренбургская область', fs_code:56, oktmo:53, area:123702},
	'om': {name:'Омская область', fs_code:55, oktmo:52, area:141140},
	'or': {name:'Орловская область', fs_code:57, oktmo:54, area:24652},
	'pe': {name:'Пермский край', fs_code:59, oktmo:57, area:160236},
	'pr': {name:'Приморский край', fs_code:25, oktmo:5, area:164673},
	'ps': {name:'Псковская область', fs_code:60, oktmo:58, area:55399},
	'pz': {name:'Пензенская область', fs_code:58, oktmo:56, area:43352},
	'ro': {name:'Ростовская область', fs_code:61, oktmo:60, area:100967},
	'rz': {name:'Рязанская область', fs_code:62, oktmo:61, area:39605},
	'sa': {name:'Республика Саха (Якутия)', fs_code:14, oktmo:98, area:3083523},
	'se': {name:'Севастополь', fs_code:91, oktmo:67, area:864},
	'sh': {name:'Сахалинская область', fs_code:65, oktmo:64, area:87101},
	'sm': {name:'Смоленская область', fs_code:67, oktmo:66, area:49779},
	'so': {name:'Республика Северная Осетия — Алания', fs_code:15, oktmo:90, area:7987},
	'sp': {name:'Санкт-Петербург', fs_code:78, oktmo:40, area:1403},
	'sr': {name:'Саратовская область', fs_code:64, oktmo:63, area:101240},
	'ss': {name:'Самарская область', fs_code:63, oktmo:36, area:53565},
	'st': {name:'Ставропольский край', fs_code:26, oktmo:7, area:66160},
	'sv': {name:'Свердловская область', fs_code:66, oktmo:65, area:194307},
	'ta': {name:'Республика Татарстан', fs_code:16, oktmo:92, area:67847},
	'tb': {name:'Тамбовская область', fs_code:68, oktmo:68, area:34462},
	'tl': {name:'Тульская область', fs_code:71, oktmo:70, area:25679},
	'tm': {name:'Томская область', fs_code:70, oktmo:69, area:314391},
	'tr': {name:'Тверская область', fs_code:69, oktmo:28, area:84201},
	'tu': {name:'Тюменская область', fs_code:72, oktmo:71, area:1464173},
	'tv': {name:'Республика Тыва', fs_code:17, oktmo:93, area:168604},
	'ud': {name:'Удмуртская Республика', fs_code:18, oktmo:94, area:42061},
	'ul': {name:'Ульяновская область', fs_code:73, oktmo:73, area:37181},
	'vl': {name:'Волгоградская область', fs_code:34, oktmo:18, area:112877},
	'vm': {name:'Владимирская область', fs_code:33, oktmo:17, area:29084},
	'vn': {name:'Воронежская область', fs_code:36, oktmo:20, area:52216},
	'vo': {name:'Вологодская область', fs_code:35, oktmo:19, area:144527},
	'ya': {name:'Ямало-Ненецкий автономный округ', fs_code:89, oktmo:719, area:769250},
	'yr': {name:'Ярославская область', fs_code:76, oktmo:78, area:36177},
	'zb': {name:'Забайкальский край', fs_code:92, oktmo:76, area:431892},
	'lr': {name:'Луганская Народная Республика', fs_code:'', oktmo:101, area:0},
	'dr': {name:'Донецкая Народная Республика', fs_code:'', oktmo:100, area:0},
	'hs': {name:'Херсонская область', fs_code:'', oktmo:103, area:0},
	'za': {name:'Запорожская область', fs_code:'', oktmo:102, area:0},
}

export {
	code2region
}
